import React from 'react';
import { useTranslation } from 'react-i18next';

const HowItWorksFlow = () => {
    const { t } = useTranslation();
    return (
        <section id="how-it-works" className="py-20 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <h2 className="text-3xl font-bold text-gray-900 text-center mb-12">
                    {t('howItWorks.title')}
                </h2>

                {/* Fasi principali */}
                <div className="grid grid-cols-1 md:grid-cols-5 gap-6 text-center mb-16">
                    {[
                        {
                            icon: '📱',
                            title: 'Tocca lo schermo',
                            desc: 'Inizia l’ordine al nostro chiosco interattivo.'
                        },
                        {
                            icon: '🍝',
                            title: 'Scegli la pasta',
                            desc: 'Corta, lunga, integrale o senza glutine. Varia ogni settimana!'
                        },
                        {
                            icon: '⚖️',
                            title: 'Decidi la quantità',
                            desc: 'Scegli quanti grammi vuoi. Paga solo ciò che mangi.'
                        },
                        {
                            icon: '🍅',
                            title: 'Aggiungi sugo e bevanda',
                            desc: 'Puoi personalizzare con sughi e bevande a parte.'
                        },
                        {
                            icon: '🧾',
                            title: 'Paga e ritira',
                            desc: 'Ricevi lo scontrino con numero d’ordine. Aspetta il tuo turno!'
                        }
                    ].map((step, index) => (
                        <div key={index}>
                            <div
                                className="w-20 h-20 mx-auto mb-4 flex items-center justify-center rounded-full text-3xl bg-orange-100">
                                {step.icon}
                            </div>
                            <h4 className="font-semibold text-lg text-gray-900 mb-1">{t(`howItWorks.steps.${index}.title`)}</h4>
                            <p className="text-gray-600 text-sm">{t(`howItWorks.steps.${index}.description`)}</p>
                        </div>
                    ))}
                </div>

                {/* Descrizione concettuale */}
                <div className="max-w-3xl mx-auto text-center text-gray-700 text-base leading-relaxed">
                    <p>
                        {t('howItWorks.description')}
                    </p>
                </div>
            </div>
        </section>
    );
};

export default HowItWorksFlow;
